module.exports = __webpack_public_path__ + "static/media/no-results-reservation.e1eb2555.svg";